
import {defineComponent} from 'vue'

export default defineComponent({
    name: "ButtonCloseFilter",
    props: {
        text: {
            type: String,
            required: true
        }
    }
});
